import { render, staticRenderFns } from "./Snapshot.vue?vue&type=template&id=71b78bb0&"
import script from "./Snapshot.vue?vue&type=script&lang=js&"
export * from "./Snapshot.vue?vue&type=script&lang=js&"
import style0 from "./Snapshot.vue?vue&type=style&index=0&id=71b78bb0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports